/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatedUserRequestOmitted
 */
export interface UpdatedUserRequestOmitted {
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    countryState?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    mlsId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatedUserRequestOmitted
     */
    enabledMlsProviders?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    officeName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatedUserRequestOmitted
     */
    website?: string | null;
}

/**
 * Check if a given object implements the UpdatedUserRequestOmitted interface.
 */
export function instanceOfUpdatedUserRequestOmitted(value: object): value is UpdatedUserRequestOmitted {
    return true;
}

export function UpdatedUserRequestOmittedFromJSON(json: any): UpdatedUserRequestOmitted {
    return UpdatedUserRequestOmittedFromJSONTyped(json, false);
}

export function UpdatedUserRequestOmittedFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedUserRequestOmitted {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'countryState': json['countryState'] == null ? undefined : json['countryState'],
        'country': json['country'] == null ? undefined : json['country'],
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'enabledMlsProviders': json['enabledMlsProviders'] == null ? undefined : json['enabledMlsProviders'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'website': json['website'] == null ? undefined : json['website'],
    };
}

export function UpdatedUserRequestOmittedToJSON(json: any): UpdatedUserRequestOmitted {
    return UpdatedUserRequestOmittedToJSONTyped(json, false);
}

export function UpdatedUserRequestOmittedToJSONTyped(value?: UpdatedUserRequestOmitted | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'timezone': value['timezone'],
        'countryState': value['countryState'],
        'country': value['country'],
        'mlsId': value['mlsId'],
        'enabledMlsProviders': value['enabledMlsProviders'],
        'phoneNumber': value['phoneNumber'],
        'officeName': value['officeName'],
        'website': value['website'],
    };
}

